import { createSelector } from '@reduxjs/toolkit';
import { toBuildingSelectItem } from 'src/components/BuildingSelect/BuildingSelect';
import { toFloorSelectItem } from 'src/components/FloorSelect/FloorSelect';
import { toTownSelectItem } from 'src/components/TownSelect/TownSelect';

import { getBuildings } from '../buildings/selectors';
import { getFloors } from '../floors/selectors';
import { getTowns } from '../towns/selectors';
import { StoreState } from '../types';

import { AdminState } from './types';

export const getAdminState = (state: StoreState): AdminState => state.admin;

export const getAdminTownId = createSelector(
  getAdminState,
  state => state.townId,
);

export const getAdminBuildingId = createSelector(
  getAdminState,
  state => state.buildingId,
);

export const getAdminFloorId = createSelector(
  getAdminState,
  state => state.floorId,
);

export const getAdminTownSelectItem = createSelector(
  getAdminTownId,
  getTowns,
  (townId, towns) => {
    const currentTown = townId ? towns.get(townId) : undefined;
    return currentTown ? toTownSelectItem(currentTown) : undefined;
  },
);

export const getAdminBuildingSelectItem = createSelector(
  getAdminBuildingId,
  getBuildings,
  (buildingId, buildings) => {
    const currentBuilding = buildingId ? buildings.get(buildingId) : undefined;
    return currentBuilding ? toBuildingSelectItem(currentBuilding) : undefined;
  },
);

export const getAdminFloorSelectItem = createSelector(
  getAdminFloorId,
  getFloors,
  (floorId, floors) => {
    const currentFloor = floorId ? floors.get(floorId) : undefined;
    return currentFloor ? toFloorSelectItem(currentFloor) : undefined;
  },
);
